import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import Portfolio from './pages/Portfolio';
import Maintenance from './pages/Maintenance';
import Settings from './pages/Settings';
import Demo from './pages/Demo';
import Placeholder from './pages/Placeholder';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="maintenance" element={<Maintenance />} />
          <Route path="leases" element={<Placeholder title="Leases" />} />
          <Route path="reports" element={<Placeholder title="Reports" />} />
          <Route path="demo" element={<Demo />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;